'use client'

import { useEffect } from 'react'

/**
 * Warms a lazy chunk on the user's first interaction (pointer, key, or touch)
 * so opening the UI that needs it feels instant, without paying the download
 * or parse cost during initial page load.
 */
export function usePrefetchOnFirstInteraction(prefetch: () => Promise<unknown>) {
  useEffect(() => {
    const warm = () => {
      void prefetch()
    }
    const options: AddEventListenerOptions = { once: true, passive: true }
    window.addEventListener('pointerdown', warm, options)
    window.addEventListener('keydown', warm, options)
    window.addEventListener('touchstart', warm, options)

    return () => {
      window.removeEventListener('pointerdown', warm)
      window.removeEventListener('keydown', warm)
      window.removeEventListener('touchstart', warm)
    }
  }, [prefetch])
}
